

<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center justify-between">
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>姓<i style="padding-left: 14px;"></i>名：</span>
                            <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
                        </div>
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>手机号：</span>
                            <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
                        </div>

                    </div>
                    <fiveLevel @upFive="upFive" :sproject="project" :scommunity="community"/>
                </div>
                <el-button type="primary" @click="hanldSearch">搜索</el-button>
            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
<!--                    <el-button-->
<!--                        v-if="user.power === 6"-->
<!--                        size="small"-->
<!--                        type="danger"-->
<!--                        @click="residentDialog = true"-->
<!--                    >新增服务对象-->
<!--                    </el-button>-->
<!--                    <el-link :href="upUrl+'/uploads/demo.xls'" target="_blank" v-if="user.power === 6" class="margin-lr-xs">-->
<!--                        <el-button-->
<!--                            size="small"-->
<!--                            type="warning"-->
<!--                        >导入模版下载-->
<!--                        </el-button>-->
<!--                    </el-link>-->

<!--                    <el-button-->
<!--                        v-if="user.power === 6"-->
<!--                        size="small"-->
<!--                        type="warning"-->
<!--                        @click="importDialog = true"-->
<!--                    >导入居民-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        v-if="user.power===5"-->
<!--                        size="small"-->
<!--                        type="warning"-->
<!--                        @click="exportJuMinList"-->
<!--                    >导出居民信息-->
<!--                    </el-button>-->
                </div>
            </div>

            <el-table
                :data="residentList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%"
            >
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
                <el-table-column label="楼门户" >
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" prop="guanjia_name"></el-table-column>
                <el-table-column label="居民姓名" prop="name"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column label="IMEI" prop="IMEI"></el-table-column>

                <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="danger"
                                @click="showItem(scope.row.jumin_id)"
                            >查看
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="deleteItem(scope.row.jumin_id)"
                            >删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                class="page-all"
                background
                @current-change="getResidentList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import fiveLevel from '@/components/five-level'
import {ONLINEHOST, QAHOST} from "@/config";
import {delEquipment, getWatchPeople} from "@/api/service";

export default {
    name: "service-object",
    data() {
        return {
            upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,

            name: '',
            phone: '',
            project: 0,
            community: 0,
            building: 0,
            unit: 0,
            room: 0,
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
            setId: 0,
            setItem: null,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "服务对象", false);
        this.getResidentList()
    },
    components: {
        fiveLevel,
    },
    methods: {


        //  删除
        deleteItem(id){
            this.$confirm('您确定要解绑该居民信息吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delEquipment(id);
            if (this.residentList.length === 1 && this.page > 1) {
                this.page--;
            }
            this.getResidentList();
            this.$message.success(_state.info);
        },
        //  查看
        showItem(id){
            this.$router.push(`/home/service-object-detail/${id}`)
        },

        //  搜索
        hanldSearch() {
            this.page = 1
            this.getResidentList()
        },

        //  获取居民列表
        async getResidentList() {
            let _data = await getWatchPeople(
                this.name,
                this.phone,
                this.project,
                this.community,
                this.building,
                this.unit,
                this.room,
                this.page,
                this.limit,
            )
            if(_data.status === 200){
                this.residentList = _data.data
                this.total = _data.total_number
            }else{
                this.$message.error(_data.info)
                this.residentList = []
                this.total = 0
            }

        },
        //  同步更新五级联动
        upFive(val) {
            this.project = val.project
            this.community = val.community
            this.building = val.building
            this.unit = val.unit
            this.room = val.room
        }
    },
    filters: {
    },
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
